import { Card, CardBody, CardHeader, CardTitle, Alert } from '@/common'
import { useAppConfig } from '@/shared/hooks/api/appConfig'
import { AddAssetWithIdPayload } from '../useAssetInstances'
import { ProductionRouteAsset } from '@/features/production-routes/api/ProductionRouteModel'
import AssetCategoryEditor from '../components/AssetCategoryEditor'
import { useTranslation } from 'react-i18next'

export function EmissionsControlAssetEditor({
  selectedAssets,
  areAssetsUsed,
  updateAreAssetsUsed,
  addAssetWithId,
  removeAssetWithId,
  updateAssetWithId,
  removeMultipleAssets,
  id
}: {
  selectedAssets: ProductionRouteAsset[]
  areAssetsUsed?: boolean
  updateAreAssetsUsed?: (value: boolean) => void
  addAssetWithId: (payload: AddAssetWithIdPayload) => void
  removeAssetWithId: (assetId: number) => void
  updateAssetWithId: (assetId: number, asset: ProductionRouteAsset) => void
  removeMultipleAssets: (ids: number[]) => void
  id: string
}) {
  const { t } = useTranslation()
  const { assetsById } = useAppConfig().config
  const assetDefinitions = [
    assetsById['afterburners__afterburning_chambers'],
    assetsById['dry_scrubbing'],
    assetsById['wet_scrubbing']
  ]

  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle title={t(`emissionPoints:emissions_control.title`)} />
        </CardHeader>
        <CardBody className="space-y-4">
          <Alert type="info" className="whitespace-pre-line">
            {t(`emissionPoints:emissions_control.callout`)}
          </Alert>
          <AssetCategoryEditor
            title={t(`emissionPoints:emissions_control.assetCategories.emissions_control.title`)}
            booleanQuestion={{
              question: t(
                `emissionPoints:emissions_control.assetCategories.emissions_control.booleanQuestion`
              ),
              value: areAssetsUsed || false,
              name: 'emissionsControl',
              update: updateAreAssetsUsed
            }}
            selectedAssets={selectedAssets}
            addAssetWithId={addAssetWithId}
            removeAssetWithId={removeAssetWithId}
            updateAssetWithId={updateAssetWithId}
            removeMultipleAssets={removeMultipleAssets}
            id={id}
            assetDefinitions={assetDefinitions}
            technologyTypeQuestion={t(
              `emissionPoints:emissions_control.assetCategories.emissions_control.technologyTypeQuestion`
            )}
          />
        </CardBody>
      </Card>
    </>
  )
}
